/**
 * Configuração do Cognito (CMS auth).
 *
 * Os valores vêm de variáveis de ambiente embutidas no bundle em build-time
 * (prefixo VITE_). Após criar o User Pool via Terraform, copie os outputs
 * `cognito_user_pool_id` e `cognito_client_id` para o `.env` e rebuilde.
 */
export const COGNITO_USER_POOL_ID = import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '';
export const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID ?? '';
export const AWS_REGION = import.meta.env.VITE_AWS_REGION ?? 'sa-east-1';

/** Indica se o Cognito está configurado (evita crash quando faltam envs). */
export const COGNITO_CONFIGURED = Boolean(COGNITO_USER_POOL_ID && COGNITO_CLIENT_ID);
